import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { APP_ROUTES } from '@taxora-business-core/util/constants/app-routes.constant';

export const checkEmailGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const store = inject(Store);
  const selector = route.data['emailSelector'];
  const email = store.selectSnapshot(selector);

  if (!email) {
    router.navigate([APP_ROUTES.AUTH.ROOT]);
    return false;
  }

  return true;
};
